export default "__VITE_ASSET__BCiF4h8w__"